export default __webpack_public_path__ + "static/media/undraw_High_five.f8c0094f.svg";